//
// VerticalConstraint.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "@sas-dvr/ltjs-commons/styles/AnchorPosition";
import "./PositionedModel";

var VerticalConstraint = createModule("BIRD::VerticalConstraint", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        offset: 7,
        anchor: 1,
        position: 4,
        anchorPosition: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default VerticalConstraint;
